const fields = [
    { name: 'stateId', label: 'State', type: 'lookup-select', source: 'operational-states', labelField: 'stateName', resolveFromOptions: true, required: true },
    { name: 'commodityId', label: 'Commodity', type: 'lookup-select', idType: 'guid', source: 'commodities', labelField: 'commodityName', resolveById: true, required: true },
    { name: 'licenseTypeId', label: 'License Type', type: 'lookup-select', idType: 'guid', source: 'license-types', labelField: 'licenseTypeName', resolveById: true, required: true },
    { name: 'stateLicenseName', label: 'State License Name', type: 'text', required: true, maxLength: 100 },
    { name: 'isRequired', label: 'Required', type: 'checkbox', defaultValue: false },
    { name: 'utilityCommissionLicenseURL', label: 'License URL', type: 'url' },
    { name: 'stateName', type: 'hidden', displayOnly: true },
    { name: 'commodityName', type: 'hidden', displayOnly: true },
    { name: 'licenseTypeName', type: 'hidden', displayOnly: true },
];
export default fields;
